export const LayoutDoneServiceSymbol = Symbol('LayoutDoneService')
export const InternalNextRenderDoneSymbol = Symbol('InternalNextRenderDoneSymbol')
export const LayoutDiagnosticSymbol = Symbol('LayoutDiagnostic')
